// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"630":"f190ab5a","655":"06e843ba","715":"454482c4","750":"39172b75"}[chunkId] + ".chunk.js";
};